import type { CSSProperties, ReactNode } from 'react';

// Logo APRIL Moto inliné (vecteur, aucun asset) — mêmes couleurs que la vue
// Blade mutualisée (kit apiclient) pour un rendu identique cross-stack.
const APRIL_LOGO_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="30" viewBox="0 0 752.24 381.66" role="img" aria-label="APRIL Moto"><g fill="#003c61"><path d="M502.49 244.91h7.22l14.32 31.98 14.26-31.98h7.16v40.79h-6.69v-27.93l-12.44 27.93h-4.64l-12.5-27.93v27.93h-6.69v-40.79z"/><use xlink:href="#B"/><path d="M600.04 258.82h-3.81v-5.46h3.81v-8.04h6.75v8.04h7.86v5.46h-7.86v17.9c0 2.41.94 3.4 3.76 3.4h4.11v5.58h-5.28c-5.75 0-9.33-2.41-9.33-8.98v-17.9z"/><use xlink:href="#B" x="66.56"/></g><path d="M155.53 152.3h31.05c-15.27-34.02-49.42-56.31-89.08-56.31v68.76c0 15.11 12.4 27.65 27.65 27.19h37.78c-4.99-9.36-7.4-20.44-7.4-32.18v-7.46z" fill="#639e30"/><path d="M230.12 225.98c-36.2 0-65.13-28.3-65.13-64.22h37.06c15.39 0 28.08 12.54 28.08 28.08v36.14z" fill="#f8aa36"/><path d="M569 115.41h0c0-5.43-2-10-5.71-13.99-3.14-3.14-7.14-4.57-11.42-5.14l-1.71-.29v52.26h0v34.27c0 5.14 4.28 9.42 9.42 9.42s9.42-4.28 9.42-9.42v-32.56h0v-34.55zm-37.18-19.42h0-15.14 0-.29-5.43c-13.42 0-24.85 4.57-34.27 13.99-9.71 9.42-14.28 20.56-14.28 33.98v47.98l1.71-.29c4.28-.57 8-2.28 11.42-5.71 4-4 5.71-8.28 5.71-13.71v-28.27-.29h0 0c0-8.28 2.86-15.42 8.57-21.13 5.71-6 12.85-8.85 21.13-8.85h20.85c4.85 0 8.85-4 8.85-8.85.03-5.14-3.97-8.85-8.83-8.85zm122.87 94.24c-.57-4-2.28-7.43-5.14-10.57h0c-3.71-3.71-8-5.43-13.14-5.43h-9.42 0c-8.28 0-15.42-3.14-21.13-8.85-5.71-6-8.57-13.14-8.57-21.13h0 0v-19.42-1.43-18.56c0-5.14-4.28-9.42-9.42-9.42h0 0c-4.85 0-8.85 4-9.42 8.85v.86h0v23.13h0v.29 15.42c0 13.42 4.85 24.56 14.28 33.98 9.71 9.42 20.85 13.99 34.27 13.99h27.99l-.3-1.71zm-322.86-80.25c-9.71-9.42-21.13-13.99-34.27-13.99-13.42 0-24.56 4.57-34.27 13.99s-14.28 20.85-14.28 33.98c0 13.42 4.85 24.56 14.28 33.98 9.71 9.42 20.85 13.99 34.27 13.99h48.83v-47.98c.01-13.12-4.85-24.54-14.56-33.97h0zm-4.57 64.26h-29.7 0c-8.28 0-15.42-3.14-21.13-8.85s-8.57-12.85-8.57-21.13v-.29h0c0-8.28 2.86-15.42 8.57-21.42s12.85-9.14 21.13-9.14h0 .29c8.28 0 15.42 3.14 21.13 9.14s8.57 13.14 8.57 21.42v30.27h-.29zm111.4-64.26h0c-9.71-9.42-21.13-13.99-34.27-13.99-13.42 0-24.56 4.57-34.27 13.99s-14.28 20.85-14.28 33.98v81.96l1.71-.29c4.28-.57 8-2.28 11.42-5.71 4-4 5.71-8.57 5.71-13.99v-13.99h29.7c13.42-.57 24.85-5.14 34.27-14.56 9.71-9.42 14.28-20.56 14.28-33.98.01-12.57-4.84-23.99-14.27-33.42zm-4.56 33.99h0 0c0 8.28-2.86 15.42-8.57 21.42s-12.85 8.85-21.13 8.85h-29.99v-29.99-.29h0 0c0-8.28 2.86-15.42 8.57-21.13 5.43-5.71 11.99-8.57 19.42-8.85v.29l1.71-.29c8.28 0 15.42 3.14 21.13 9.14 5.71 5.42 8.57 12.56 8.86 20.85h0z" fill="#003c61"/><defs><path id="B" d="M571.92 286.22c-9.21 0-16.2-6.57-16.2-16.73s7.28-16.67 16.49-16.67 16.49 6.51 16.49 16.67-7.51 16.73-16.78 16.73zm0-5.81c4.99 0 9.92-3.58 9.92-10.92s-4.75-10.86-9.74-10.86c-5.05 0-9.57 3.52-9.57 10.86s4.34 10.92 9.39 10.92z"/></defs></svg>';

export const authStyles: Record<string, CSSProperties> = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background:
            'radial-gradient(900px 460px at 15% -10%, rgba(62,170,196,.16), transparent 60%), linear-gradient(160deg, #f4f8fb 0%, #e8eff5 100%)',
    },
    card: {
        position: 'relative',
        width: '100%',
        maxWidth: 408,
        background: '#fff',
        borderRadius: 20,
        boxShadow: '0 20px 44px -26px rgba(0,60,97,.40), 0 4px 14px -8px rgba(0,60,97,.18)',
        padding: '44px 40px 32px',
        overflow: 'hidden',
    },
    liseret: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        background: 'linear-gradient(90deg, #003c61 0%, #3eaac4 100%)',
    },
    brand: { textAlign: 'center', marginBottom: 26 },
    lockup: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 },
    logo: { display: 'inline-flex', lineHeight: 0 },
    sep: { width: 1, height: 22, background: '#d2dbe1', display: 'inline-block' },
    appname: { fontSize: 15, fontWeight: 600, letterSpacing: '-0.01em', color: '#003c61' },
    title: { fontSize: 22, fontWeight: 650, letterSpacing: '-0.01em', margin: '22px 0 4px', color: '#18313f' },
    subtitle: { margin: 0, fontSize: 13, color: '#8499a4' },
    rate: { margin: '0 0 4px', fontSize: 13, color: '#d02e41', textAlign: 'center' },
    notice: { margin: '0 0 16px', padding: '11px 14px', borderRadius: 10, fontSize: 13, lineHeight: 1.4, background: '#e7f4ec', border: '1px solid rgba(47,143,91,.25)', color: '#2f8f5b' },
    linkrow: { display: 'block', textAlign: 'center', marginTop: 16, fontSize: 13 },
    link: { color: '#0d557a', textDecoration: 'none' },
    foot: { marginTop: 26, textAlign: 'center', fontSize: 12, color: '#8499a4' },
};

export const authSubmitProps = {
    className: 'w-full text-white',
    style: { backgroundColor: '#0d557a' } as CSSProperties,
};

export interface AuthCardProps {
    appName?: string;
    heading: string;
    subtitle: string;
    children: ReactNode;
}

/**
 * Coquille commune des écrans d'auth (login, forgot, reset) : fond dégradé,
 * carte + liseré, lockup logo APRIL + nom d'app, titre, sous-titre, contenu.
 * Alignée sur la vue Blade `sso::layout` du kit — rendu identique cross-stack.
 */
export function AuthCard({ appName, heading, subtitle, children }: AuthCardProps) {
    return (
        <div style={authStyles.page}>
            <main style={authStyles.card}>
                <span style={authStyles.liseret} aria-hidden="true" />

                <div style={authStyles.brand}>
                    <div style={authStyles.lockup}>
                        <span style={authStyles.logo} dangerouslySetInnerHTML={{ __html: APRIL_LOGO_SVG }} />
                        {appName ? (
                            <>
                                <span style={authStyles.sep} aria-hidden="true" />
                                <span style={authStyles.appname}>{appName}</span>
                            </>
                        ) : null}
                    </div>
                    <h1 style={authStyles.title}>{heading}</h1>
                    <p style={authStyles.subtitle}>{subtitle}</p>
                </div>

                {children}

                <p style={authStyles.foot}>© {new Date().getFullYear()} APRIL Moto</p>
            </main>
        </div>
    );
}
